import { useGetActiveDriversQuery } from '../services';
import { ACTIVE_DRIVERS_LIST_POLLING_INTERVAL } from '../config/pollingConfig';

export const useActiveDrivers = () => {
  const { data, isLoading, error } = useGetActiveDriversQuery(
    {
      offset: 0,
      limit: 10,
    },
    {
      pollingInterval: ACTIVE_DRIVERS_LIST_POLLING_INTERVAL,
      refetchOnMountOrArgChange: true,
    }
  );

  return {
    activeDrivers: data?.data || [],
    isLoading,
    error,
  };
};
